export default {
  state: {
    AreaCountry:[],
    RoleList:[],
    lang:'zh',
    //会议相关
    currentMeetingCode:'',
    currentMeetingObj:{},
    currentMeetingtTopicArr:[],
    crSubmissionEntityList:[],//[’期刊1‘，'期刊2']
    doubleSubmissionOrNot:0,//双重提交 0否， 1是
    MeetingList:[],
    authorization:null,
    isFinishedInfo:false,
  },
  mutations: {
    setAreaCountry(state, val) {
      state.AreaCountry = val;
    },
    setRoleList(state, val) {
      state.RoleList = val;
    },
    setLang(state, val){
      state.lang = val;
    },
    setCurrentMeetingCode(state, val){
      state.currentMeetingCode = val;
    },
    setCurrentMeetingObj(state, val){
      state.currentMeetingObj = val;
    },
    setCurrentMeetingtTopicArr(state, val){
      state.currentMeetingtTopicArr = val;
    },
    setCrSubmissionEntityList(state, val){
      state.crSubmissionEntityList = val;
    },
    setDoubleSubmissionOrNot(state, val){
      state.doubleSubmissionOrNot = val;
    },
    setMeetingList(state, val){
      console.log(val);
      state.MeetingList = val;
    },
    setAuthorization(state, val){
      state.authorization = val;
    },
    setIsFinishedInfo(state, val){
      state.isFinishedInfo = val;
    }
  },
  actions: {}
}
